/** Solar elevation, not the observer's clock: both dawn and dusk use the same
 * continuous ivory → peach → rose → violet progression. Alpha is independent. */
export const CLOUD_LIGHT_GLSL=/* glsl */`
vec3 cloudSolarTint(float height) {
  float gold = 1.0 - smoothstep(.08, .38, height);
  float rose = 1.0 - smoothstep(-.035, .09, height);
  float violet = 1.0 - smoothstep(-.20, -.075, height);
  vec3 color = mix(vec3(1.0, .97, .90), vec3(1.0, .72, .43), gold);
  color = mix(color, vec3(1.0, .43, .58), rose);
  return mix(color, vec3(.50, .40, .66), violet);
}
`;
